import * as React from 'react';
import { Button, Icon } from 'kui';
import { ICardDatesCloseButton } from './types';
import { CARD_DATES_FROM_CHECKITEM, CARD_DATES_FROM_SUBCARD } from './constants';
import { CLASS_DATEPICKER } from '../../../../../base/components/Datepicker/components/constants';

export function CardDatesCloseButton({
    dateCardId,
    name,
    onClick
}: ICardDatesCloseButton) {
    return (
        <Button
            variant={'icon'}
            className={CLASS_DATEPICKER + '__item-link'}
            onClick={name ? () => onClick(dateCardId) : null}
            tooltip={name ? `${CARD_DATES_FROM_SUBCARD} ${name}` : CARD_DATES_FROM_CHECKITEM}
        >
            <Icon
                xlink={'subcard'}
                size={24}
            />
        </Button>
    );
}
